enum ObstetricalExamResultState {
    NotDone = 0,
    Normal = 1,
    Abnormal = 2
}

export { ObstetricalExamResultState };
